import { render, staticRenderFns } from "./gnb-login-button.vue?vue&type=template&id=05512395&"
import script from "./gnb-login-button.vue?vue&type=script&lang=js&"
export * from "./gnb-login-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports